import type { CustomFieldFormValues } from '../types';

type FormState = {
	values?: Partial<CustomFieldFormValues>;
	errors?: Partial<Record<string, unknown>>;
};

export const isCustomFieldFormValid = (formState: FormState | null | undefined): boolean => {
	if (!formState?.values) {
		return false;
	}

	const { fieldName, fieldType, peopleFormat, currencyCode } = formState.values;
	const errors = formState.errors;
	const fieldTypeValue = fieldType?.value;
	const shouldShowCurrencyField = fieldTypeValue === 'NUMBER' && formState.values?.numberFormat?.value === 'CURRENCY';

	return Boolean(
		fieldName?.trim() &&
		fieldType &&
		!errors?.fieldName &&
		!errors?.fieldDescription &&
		(fieldTypeValue !== 'SELECTOR' || !errors?.fieldOptions) &&
		(fieldTypeValue !== 'USER' || peopleFormat) &&
		(!shouldShowCurrencyField || currencyCode),
	);
};
